export const READ = 'read'
export const INSERT = 'insert'
export const UPDATE = 'update'
export const REMOVE = 'remove'
